export default "<div class=\"button-main d-inline-block\" (click)=\"onClickLocal()\">\n  {{ title }}\n</div>\n";